import create from 'zustand';

export const useCategoryStore = create(set => ({
    allCategories: [],
    category: 'otros',
    selectedCategory: {},
    setSelectedCategory: (categoryData) => set({selectedId: categoryData}),
    setCategory: (newCategory) => set({category: newCategory}),
    setAllCategories: (allCategories) => set({allCategories: allCategories})
}))